// Import role action types to be used
import { ADD_ROLE_REQUEST, ADD_ROLE_SUCCESS, ADD_ROLE_FAILURE, FETCH_ROLES_REQUEST, FETCH_ROLES_SUCCESS, FETCH_ROLES_FAILURE, UPDATE_ROLE_REQUEST, UPDATE_ROLE_SUCCESS, UPDATE_ROLE_FAILURE, DELETE_ROLE_REQUEST, DELETE_ROLE_SUCCESS, DELETE_ROLE_FAILURE, CLEAR_ROLES_ERROR } from './roleActionTypes';

// Import the axios instance from api module
import api from '../../api/api';
import { toast } from "react-toastify";



// Define and export a function for creating a role
export const addRole = (roleData) => {
    return async (dispatch) => {
        dispatch({ type: ADD_ROLE_REQUEST });
        
        try {
            const response = await api.post('/Role', roleData);
            
            dispatch({ type: ADD_ROLE_SUCCESS, payload: response.data });
            // Display toast notification upon successful creation of a role
            toast.success("Role created successfully");
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    dispatch({ type: ADD_ROLE_FAILURE, payload: "Invalid data. Please check your input fields." })
                    toast.error("Role could not be created due to invalid inputs. Please try again");
                } else if (error.response.status === 500) {
                    dispatch({ type: ADD_ROLE_FAILURE, payload: "Our server seems to be having issues. Please try again later." })
                    toast.error("Role could not be created. Please try again");
                } else {
                    dispatch({ type: ADD_ROLE_FAILURE, payload: "An unknown error occurred. Please try again soon." })
                    toast.error("Role could not be created. Please try again");
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: ADD_ROLE_FAILURE, payload: "No response was received from the server. Please try again later." })
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: ADD_ROLE_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
            }
        }
    }
};



// Define and export a function for fetching roles
export const fetchRoles = () => {
    return async (dispatch) => {
        dispatch({ type: FETCH_ROLES_REQUEST });

        try {
            const response = await api.get('/Role');
            
            dispatch({ type: FETCH_ROLES_SUCCESS, payload: response.data });
            // toast.success("Roles fetched successfully");

        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                if (error.response.status === 400) {
                    dispatch({ type: FETCH_ROLES_FAILURE, payload: "Bad request. Please check your input." });
                } else if (error.response.status === 404) {
                    dispatch({ type: FETCH_ROLES_FAILURE, payload: "No roles were found. Please try again later." });
                } else if (error.response.status === 500) {
                    dispatch({ type: FETCH_ROLES_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                } else {
                    dispatch({ type: FETCH_ROLES_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: FETCH_ROLES_FAILURE, payload: "No response from the server. Please try again later." });
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: FETCH_ROLES_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
            }
        }
    }
};



// Define and export a function for updating a role
export const updateRole = (roleId, updatedRoleData) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_ROLE_REQUEST});

        try {
            const response = await api.put(`/Role/${roleId}`, updatedRoleData);

            dispatch({ type: UPDATE_ROLE_SUCCESS, payload: response.data });
            toast.success("Role updated successfully");
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    dispatch({ type: UPDATE_ROLE_FAILURE, payload: "Invalid data. Please check your input fields." });
                    toast.error("Role update failed. Please try again.");
                } else if (error.response.status === 404) {
                    dispatch({ type: UPDATE_ROLE_FAILURE, payload: "Role not found. Please try again" });
                    toast.error("The role you are trying to update does not exist.");
                } else if (error.response.status === 500) {
                    dispatch({ type: UPDATE_ROLE_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                    toast.error("Role update failed. Please try again later.");
                } else {
                    dispatch({ type: UPDATE_ROLE_FAILURE, payload: "An unknown error occurred. Please try again soon" });
                    toast.error("Role update failed. Please try again.");
                }
            } else if (error.request) {
                dispatch({ type: UPDATE_ROLE_FAILURE, payload: "No response was received from the server. Please try again later." })
            } else {
                dispatch({ type: UPDATE_ROLE_FAILURE, payload: "An error occurred while setting up the request. Please try again later." })
            }
        }
    }
}



// Define and export a function for deleting a role
export const deleteRole = (roleId) => {
    return async (dispatch) => {
        dispatch({ type:  DELETE_ROLE_REQUEST});
        
        try {
            await api.delete(`/Role/ ${roleId}`);

            dispatch({ type: DELETE_ROLE_SUCCESS, payload: roleId });
            toast.success("Role deleted successfully")
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    dispatch({ type: DELETE_ROLE_FAILURE, payload: "Role not found. Please try again." });
                    toast.error("The role you are trying to delete does not exist.");
                } else if (error.response.status === 500) {
                    dispatch({ type: DELETE_ROLE_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                    toast.error("Role deletion failed. Please try again later.");
                } else {
                    dispatch({ type: DELETE_ROLE_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                    toast.error("Role deletion failed. Please try again.");
                }
            } else if (error.request) {
                dispatch({ type: DELETE_ROLE_FAILURE, payload: "No response was received from the server. Please try again later." });
            } else {
                dispatch({ type: DELETE_ROLE_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
            }
        };
    };
};



// Define and export a function for clearing the fetchRoles error
export const clearRolesError = () => {
    return { type: CLEAR_ROLES_ERROR }
}